import { type FC, type ReactNode } from "react";
import { Link } from "@root/shared/components/Link";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  text: string;
  url: string;
  iconName: string;
  canAction: boolean;
  cannotActionType?: "inactive" | "hidden";
  children: ReactNode | string;
  alignItems?: "center" | "left";
};

export const PrimaryActionWithNotification: FC<Props> = ({
  text,
  url,
  iconName,
  canAction,
  cannotActionType = "hidden",
  children,
  alignItems = "center",
}) => {
  // Actionできる場合はそのまま表示
  // Actionできない場合はボタンを非表示 or ボタンを非活性
  const ActionButton: FC = () => {
    if (canAction) {
      return (
        <div className={styles.buttonContainer}>
          <Link theme="primary" href={url} className={styles.actionButton}>
            <Icon name={iconName} />
            <span className={styles.text}>{text}</span>
          </Link>
        </div>
      );
    }
    if (cannotActionType === "inactive") {
      return (
        <div className={styles.buttonContainer}>
          <Link theme="disabled" href={url} className={styles.actionButton}>
            <Icon name={iconName} />
            <span className={styles.text}>{text}</span>
          </Link>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={styles.container({ align: alignItems })}>
      <ActionButton />
      {typeof children === "string" ? (
        <div
          // NOTE: erbからコンポーネントを呼ぶ際にはchildrenを文字列で渡す必要があるため暫定的にdangerouslySetInnerHTMLを使用
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: children }}
        />
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};
